import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { pageModuleModel } from "app/models/store/page-module-model";
import { pageModuleMnemonic } from './pageModuleMnemonic.action';

@State<pageModuleModel>({
   name: 'pageModule',
   defaults: {
      currentPageMnemonic: '',
      currentModuleMnemonic: '',
      currentMenuId: null,
      previousPageMnemonic: '',
      previousModuleMnemonic: '',
      previousMenuId: null
   }
})
@Injectable()
export class pageModuleMnemonicState {
   @Selector()
   static getPageModule(state: pageModuleModel) {
      return state;
   }
    

   @Action(pageModuleMnemonic)
   pageModuleMnemonic({ getState, patchState }: StateContext<pageModuleModel>, { payload }: pageModuleMnemonic) {
      const state = getState();

      patchState({
         currentPageMnemonic: payload?.currentPageMnemonic,
         currentModuleMnemonic: payload?.currentModuleMnemonic,
         previousPageMnemonic: payload?.previousPageMnemonic,
         previousModuleMnemonic: payload?.previousModuleMnemonic
      });
   }
}